import { SxProps, Typography, useTheme } from "@mui/material";
import { useRef, useState } from "react";
import Image from "./Image";

import { FileUploadTexts } from "../../data/texts";
import { Icons } from "../../models/assets-files";
import { FileWithId } from "../../models/uploaded-file";
import { ImageService } from "../../services/image.service";
import { UtilsService } from "../../services/utils.service";
import StyledFileUploaderContainer from "../../styled-cmps/file-uploader-container";

interface FileUploaderProps {
  sx?: SxProps;
  singleFile?: boolean;
  onFilesSelected?: (files: FileWithId[]) => void;
}

const FileUploader = ({
  sx,
  onFilesSelected,
  singleFile,
}: FileUploaderProps) => {
  const theme = useTheme();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && onFilesSelected) {
      const files = addIdToFiles(event.target.files);
      onFilesSelected(files);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const addIdToFiles = (files: FileList): FileWithId[] => {
    return Array.from(files).map((file) => {
      return {
        content: file,
        createdAt: `${Date.now()}`,
        id: UtilsService.generateUniqueId(),
      };
    });
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragging(false);
    if (event.dataTransfer.files && onFilesSelected) {
      const files = addIdToFiles(event.dataTransfer.files);

      onFilesSelected(files);
    }
  };

  return (
    <StyledFileUploaderContainer
      isDragging={isDragging}
      sx={sx}
      onClick={handleClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <Image
        hideSkeleton
        sx={{ marginBottom: "5px", width: "36px", height: "45px" }}
        src={ImageService.getLocalIconPath(
          Icons.Folders.GENERAL,
          Icons.General.UploadFiles
        )}
      />
      <Typography
        sx={{
          color: theme.palette.text.primary,
          fontWeight: "500",
          fontSize: "20px",
          marginBottom: "2px",
        }}
      >
        {FileUploadTexts.SELECT_FILES}
      </Typography>
      <Typography sx={{ color: "#6785A6", fontWeight: "500" }}>
        {FileUploadTexts.DRAG_DROP}
      </Typography>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        multiple={!singleFile}
        onChange={handleFileSelect}
      />
    </StyledFileUploaderContainer>
  );
};

export default FileUploader;
